import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallTitle from '../../../common-components/common-small-title';
import parser from 'html-react-parser';
import Image from 'next/image';

type ListType = {
    title: string;
    description: string;
};

type ListMediaType = {
    title: string;
    subtitle: string;
    icon: string;
    link: string;
};

type ResultPropsType = {
    list: ListType[];
    listMedia: ListMediaType[];
};

const Result = ({ list, listMedia }: ResultPropsType) => {
    return (
        <div className="aimed-result">
            <FullWrapper isMargin={false}>
                <div className="aimed-resultWrapper">
                    <div className="aimed-resultInnerNew">
                        <div className="aimed-resultLeft">
                            <div className="aimed-resultParagrafList">
                                <div className="aimed-competition-pagePirpleBlock">
                                    <div className="aimed-competition-pageParagraf">
                                        Пятый этап&nbsp;&mdash; разработка абсолютно новой
                                        двухэтапной механики для проведения основного конкурса
                                        AI&rsquo;m Doctor. Это финальные испытания систем участников
                                        по&nbsp;постановке конкретных диагнозов, в&nbsp;результате
                                        которых будет выбрана наилучшая ИИ-система.
                                    </div>
                                </div>
                                <div className="aimed-resultParagraf">
                                    Для проведения финальных испытаний изменили процесс обмена
                                    данными между платформой и&nbsp;участниками, разработали новый
                                    алгоритм оценки интегрального результата конкурса, переработали
                                    личный кабинет клинического специалиста, в&nbsp;котором эпикриз
                                    отображается врачу ровно в&nbsp;том порядке, в&nbsp;котором его
                                    &laquo;изучала&raquo; система участника. Также сделали два новых
                                    лидерборда, которые в&nbsp;прямом эфире отображают ход
                                    испытаний: обмен между платформой и&nbsp;системами участников
                                    и&nbsp;оценки клинических специалистов.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="aimed-resultTitle">Проведение конкурса AI'm Doctor</div>
                    <div className="aimed-resultInnerNew">
                        <div className="aimed-resultLeft">
                            <div className="aimed-resultParagrafList">
                                <div className="aimed-resultParagraf">
                                    Финал состоялся 6&nbsp;ноября 2024&nbsp;в прямом эфире.
                                    В&nbsp;финальную часть конкурса вышли 4&nbsp;команды, которые
                                    показали наилучшие результаты в&nbsp;отборочных соревнованиях.
                                </div>
                                <div className="aimed-resultParagraf">
                                    На&nbsp;первом этапе финала участники получают анамнез
                                    и&nbsp;предполагают первичный диагноз. В&nbsp;базе
                                    120&nbsp;эпикризов, которые получают команды для обработки
                                    и&nbsp;постановки диагноза. После чего запрашивают медицинские
                                    исследования, которые проводились по&nbsp;пациенту,
                                    и&nbsp;получают их&nbsp;результаты. Это делается для увеличения
                                    точности итогового диагноза, который ИИ-система должна поставить
                                    за&nbsp;1&nbsp;минуту.
                                </div>
                                <div className="aimed-resultParagraf">
                                    На&nbsp;втором этапе диагнозы ИИ-систем участников
                                    верифицируются практикующими врачами. Алгоритм платформы
                                    отбирает 24&nbsp;самых интересных случая для оценки. Клинические
                                    эксперты оценивают траекторию запросов исследований
                                    в&nbsp;соответствии с&nbsp;предварительным диагнозом
                                    и&nbsp;точность заключительного диагноза.
                                </div>
                                <div className="aimed-resultParagraf">
                                    Победителем стала система, которая наиболее часто ставила точный
                                    диагноз с&nbsp;наименьшим количеством запрашиваемых
                                    исследований.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="aimed-resultTitle">Результаты</div>
                    <div className="aimed-resultInner">
                        <div className="aimed-resultLeft">
                            <div className="aimed-resultParagrafList">
                                <div className="aimed-resultParagraf">
                                    С&nbsp;нуля разработали highload-платформу для выбора наилучшего
                                    решения на&nbsp;основе&nbsp;ИИ для определения симптомов
                                    по&nbsp;набору объективных данных и&nbsp;клинических
                                    исследований, а&nbsp;также определению заключительного
                                    клинического диагноза.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="aimed-resultImgDecoration">
                <Image
                    src="/images/pic/aimed/f5.png"
                    alt="marker"
                    width={1920}
                    height={780}
                    className="aimed-resultImgDecorationItem"
                />
            </div>
            <FullWrapper>
                <div className="aimed-resultWrapper">
                    <div className="aimed-resultInner">
                        <div className="aimed-resultLeft">
                            <div className="aimed-resultParagrafList">
                                <div className="aimed-competition-pageParagraf">
                                    Помогли сформировать уникальные датасеты, на&nbsp;которых уже
                                    обучаются отечественные ИИ-системы по&nbsp;первичной диагностике
                                    легочных заболеваний и&nbsp;в&nbsp;дальнейшем станут основой
                                    системы поддержки принятия врачебных решений. В&nbsp;итоге это
                                    значительно улучшит качество медицинского обслуживания миллионов
                                    россиян, в&nbsp;том числе в&nbsp;отдаленных регионах.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="aimed-resultList">
                        {list &&
                            list.map(({ title, description }) => (
                                <div className="aimed-resultItem" key={title}>
                                    <div
                                        className="aimed-resultText"
                                        dangerouslySetInnerHTML={{ __html: title }}
                                    ></div>
                                    <div
                                        className="aimed-resultDescription"
                                        dangerouslySetInnerHTML={{ __html: description }}
                                    ></div>
                                </div>
                            ))}
                    </div>
                    <div className="aimed-resultMedia">
                        <div className="aimed-resultMediaInner">
                            <CommonSmallTitle>СМИ о проекте:</CommonSmallTitle>
                            {listMedia.map(({ title, link, subtitle, icon }) => (
                                <a
                                    key={title}
                                    href={link}
                                    target="_blank"
                                    className="aimed-resultMediaWrapper"
                                    rel="noreferrer"
                                >
                                    <img className="aimed-resultMediaIcon" src={icon} alt="icon" />
                                    <div className="aimed-resultMediaInfo">
                                        <div className="aimed-resultMediaTitle">
                                            {parser(title)}
                                        </div>
                                        <div className="aimed-resultMediaSubtitle">{subtitle}</div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Result;
